export const DEFAULT_STC_TYPE = "LIVE";
export const STC_TYPE_MAX_LENGTH = 50;
export const STC_CUSTOM_VALUE_WARNING = "非标准 STC，将按自定义值保存";

export const RECOMMENDED_STC_TYPES = [
    "LIVE",
    "TECHSTOP",
    "FERRY",
    "TRAINING",
    "MAINTENANCE",
    "TEST",
    "CANCEL",
];

export const LEGACY_STC_TYPES = [
    "REGULAR",
    "CHARTER",
    "ADHOC",
];

export const RECOMMENDED_STC_TYPE_OPTIONS = RECOMMENDED_STC_TYPES.map((value) => ({
    label: value,
    value,
}));

const RECOMMENDED_STC_TYPE_SET = new Set(RECOMMENDED_STC_TYPES);
const LEGACY_STC_TYPE_SET = new Set(LEGACY_STC_TYPES);

export function normalizeStcTypeValue(value) {
    return String(value ?? "").trim().toUpperCase().slice(0, STC_TYPE_MAX_LENGTH);
}

export function isRecommendedStcType(value) {
    const normalizedValue = normalizeStcTypeValue(value);
    return normalizedValue !== "" && RECOMMENDED_STC_TYPE_SET.has(normalizedValue);
}

export function isLegacyStcType(value) {
    const normalizedValue = normalizeStcTypeValue(value);
    return normalizedValue !== "" && LEGACY_STC_TYPE_SET.has(normalizedValue);
}

export function normalizeStcTypeEmptyValue(value) {
    const normalizedValue = normalizeStcTypeValue(value);
    return normalizedValue || null;
}

export function normalizeInheritedStcTypeValue(value) {
    const normalizedValue = normalizeStcTypeValue(value);
    return normalizedValue && !isLegacyStcType(normalizedValue) ? normalizedValue : DEFAULT_STC_TYPE;
}
